import { Timeline } from "PARTIALS/timelineScroll";
import { ww } from "bobjoll/ts/library/dom";

ww.Timeline = Timeline;